import { gql } from '@apollo/client'

export type { HistoricalSeasons } from './types/index.graphql'

export const HISTORICAL_SEASONS = gql`
  query HistoricalSeasons {
    historicalSeasons {
      name
      endRange
      startRange
    }
  }
`
